import styled from '@emotion/styled';
import { fraudAndComplianceColors } from 'src/assets/colors';
import { fontSize } from 'src/assets/fonts-config';
import { TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, ChevronDownType, ChevronDownWrapperTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })`
`;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })`
`;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' })`
    background-color: ${fraudAndComplianceColors.commonTable.bgColorRowPendingSecond} !important;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
    font-size: ${fontSize.xRegular};
    text-align: left;

    :nth-of-type(1) {
        width: 35px;
    }
    :nth-of-type(2) {
        width: 15%;
    }
    :nth-of-type(3) {
        width: 15%;
    }
    :nth-of-type(4) {
        width: 10%;
    }
    :nth-of-type(5) {
        width: 10%;
    }
    :nth-of-type(6) {
        width: 10%;
    }
    :nth-of-type(7) {
        width: 10%;
    }
    :nth-of-type(8) {
        width: 10%;
    }
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    font-size: ${fontSize.xRegular};

    :nth-of-type(1) {
        width: 35px;
    }

    :nth-of-type(2) {
        width: 15%;
    }
    :nth-of-type(3) {
        width: 15%;
    }
    :nth-of-type(4) {
        width: 10%;
    }
    :nth-of-type(5) {
        width: 10%;
    }
    :nth-of-type(6) {
        width: 10%;
    }
    :nth-of-type(7) {
        width: 10%;
    }
    :nth-of-type(8) {
        width: 10%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    span {
        display: block;
    }
`;

export const InnerTable = styled('table', { label: 'InnerTable' })`
    vertical-align: middle;
    table-layout: fixed;
    text-overflow: ellipsis;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
`;

export const ChevronDownWrapper = styled(ChevronDownWrapperTemplate, { label: 'ChevronDownWrapper' }) < ChevronDownType > `
`;

export const CustomerTab = styled('div', { label: 'CustomerTab' })`
    text-overflow: ellipsis;
`;

export const CustomerData = styled('div', { label: 'CustomerData' })`
    display: flex;
    justify-content: space-between;
`;
